import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Transformation } from './components/Transformation';
import { Recognize } from './components/Recognize';
import { Included } from './components/Included';
import { Preview } from './components/Preview';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
const META_PIXEL_ID = '2168492450372471';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="28s2ztflro5x1">
      <AnnouncementBar data-id="element-1" data-mp="23ujho4ly78zt" />
      <Hero data-id="element-2" data-mp="23t8fuac2cbbc" />
      <main data-id="element-3" data-mp="23ti5fwt74ggi">
        <StatsBar data-id="element-4" data-mp="3ik7fce9tu7pl" />
        <Transformation data-id="element-5" data-mp="3ikqy1x7ax04o" />
        <Recognize data-id="element-6" data-mp="3ijfvu1ti80fo" />
        <Included data-id="element-7" data-mp="3ihv048vgebg8" />
        <Preview data-id="element-8" data-mp="3mlj82snzz920" />
        <Bonuses data-id="element-9" data-mp="3ml12v6jcxkhy" />
        <Pricing data-id="element-10" data-mp="3mkhmvvd9p66k" />
        <Guarantee data-id="element-11" data-mp="3mjzu58ptda3e" />
        <Testimonials data-id="element-12" data-mp="3mjg8pi0yg3km" />
        <Faq data-id="element-13" data-mp="3rcj6y3gog175" />
        <FinalCta data-id="element-14" data-mp="3rbrcivytg9ig" />
      </main>
      <SiteFooter data-id="element-15" data-mp="3rcsy3udgkeef" />
    </div>;
}